<template>
  <v-container fluid>
    <base-material-card color="primary" icon="mdi-file-remove-outline" inline class="ml-0 px-5 py-4">
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">Simulação de Baixas</div>
      </template>
      <v-btn
        id="btn-nova-simulacao-baixas"
        color="success"
        dark
        elevation="1"
        class="mt-5"
        style="float: left"
        relative
        text
        medium
        @click="$router.push('edit')"
      >
        <v-icon left size="30px">mdi-plus-circle</v-icon>
        Nova Simulação
      </v-btn>
      <v-text-field
        id="simulacao-baixas-historico-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="break-search ml-auto mt-4"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 250px"
      />
      <general-progress-bars class="mt-11" :items="downloadProgressData" prefix-text="Baixando Simulação de Baixas" />
      <v-divider class="mt-10" />
      <v-data-table
        :headers="headers"
        :items="items"
        :search.sync="search"
        :header-props="{
          sortByText: 'Ordenar Por'
        }"
        :footer-props="{
          itemsPerPageText: 'Itens por Página'
        }"
        no-data-text="Nenhuma simulação de baixas disponível"
        no-results-text="Nenhum registro correspondente encontrado"
        :loading="loading"
      >
        <template v-slot:[`item.id`]="{ item }">
          {{ item.id }}
        </template>
        <template v-slot:[`item.nome`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div class="text-truncate-column" v-bind="attrs" v-on="on">
                {{ item.nome }}
              </div>
            </template>
            <span>{{ item.nome }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.data_processamento`]="{ item }">
          {{ item.data_processamento | parseToDateTimeBR }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <general-status :status="item.status" />
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            id="action-download-simulacao-baixas"
            :class="item.status != 'SUCESSO' ? 'cursor-block' : ''"
            min-width="0"
            class="px-1"
            fab
            icon
            x-small
            :loading="downloadProgressData[item.id] !== undefined ? true : false"
            :disabled="item.status != 'SUCESSO'"
            @click="downloadItem(item)"
          >
            <v-icon small>mdi-download</v-icon>
          </v-btn>
          <v-btn
            id="action-edit-simulacao-baixas"
            :class="!canEditItem(item) ? 'cursor-block' : ''"
            min-width="0"
            class="ml-n1 px-1"
            fab
            icon
            x-small
            :disabled="!canEditItem(item)"
            @click="$router.push(`edit/${item.id}`)"
          >
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                id="action-more-simulacao-baixas"
                v-bind="attrs"
                color="white"
                class="ml-1"
                height="22px"
                width="22px"
                fab
                x-small
                elevation="1"
                v-on="on"
              >
                <v-icon small>mdi mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-if="canRunItem(item)" @click="executarItem(item.id)">
                <v-list-item-title>
                  <v-icon small>mdi-play</v-icon>
                  Executar
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="duplicarItem(item.id)">
                <v-list-item-title>
                  <v-icon small>mdi-content-copy</v-icon>
                  Duplicar
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="canDeleteItem(item)" @click="openDialogDelete(item.id, item.nome)">
                <v-list-item-title>
                  <v-icon small>mdi-trash-can-outline</v-icon>
                  Deletar
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="openDialogDetalhes(item)">
                <v-list-item-title>
                  <v-icon small>mdi-file-find-outline</v-icon>
                  Detalhes
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="
                  ((dialogCreationLog = true), (dialogCreationLogData = { username: item.usuario.nome, created: item.created }))
                "
              >
                <v-list-item-title>
                  <v-icon small>mdi-table-search</v-icon>
                  Log
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:[`footer`]>
          <v-switch
            v-if="$store.getters.userIsAdmin"
            class="pa-0 pl-2 swithInterna"
            style="position: absolute"
            color="primary"
            label="Exibir Expirados"
            dense
            @change="$emit('switchProcessamentosExpirados', $event)"
          />
        </template>
        <template v-slot:[`footer.page-text`]>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="primary" v-bind="attrs" v-on="on" @click="$emit('rechargeTable')">mdi-refresh</v-icon>
            </template>
            <span>Clique aqui para recarregar as simulações de baixas</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>
    <dialog-delete
      :show-dialog="dialogDelete"
      @changeValue="dialogDelete = $event"
      @deleteTriggered="deletarItem(dialogDeleteData.id)"
    >
      <template slot="title">Deletar Simulação #{{ dialogDeleteData.id }}</template>
      <template slot="body">
        Tem certeza que deseja deletar a simulação de baixas
        <strong>{{ dialogDeleteData.nome }}</strong>
        ?
      </template>
    </dialog-delete>
    <dialog-creation-log :dialog.sync="dialogCreationLog" :item="dialogCreationLogData" />
    <general-dialog-detalhes
      ref="dialogDetalhes"
      title="Detalhes da Simulação de Baixas"
      :show-dialog="dialogDetalhes"
      @changeValue="dialogDetalhes = $event"
    >
      <template slot="body">
        <v-data-table
          :headers="[
            { text: 'Parâmetro', value: 'parametro', sortable: false },
            { text: 'Valor', value: 'valor', sortable: false }
          ]"
          :items="dialogDetalhesData"
          hide-default-footer
          class="elevation-1 style-table-dialog-detalhes"
          disable-pagination
        >
          <template v-slot:item="row">
            <tr>
              <td class="button">
                {{ row.item.parametro }}
              </td>
              <td
                v-if="'arquivo_id' in row.item"
                class="download-arquivo-detalhes-click"
                @click="downloadArquivoById(row.item.arquivo_id, row.item.arquivo_nome)"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <v-progress-circular v-if="loadingDownloadArquivoById" indeterminate color="primary" size="20" />
                      <span v-else>{{ row.item.arquivo_nome }}</span>
                    </div>
                  </template>
                  <span v-if="loadingDownloadArquivoById">AGUARDE :: Baixando arquivo [{{ row.item.arquivo_nome }}]...</span>
                  <span v-else>Clique aqui para baixar o arquivo</span>
                </v-tooltip>
              </td>
              <td v-else-if="typeof row.item.valor === 'object' && 'logs_tecnicos' in row.item.valor" class="button">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="ml-btn-logs"
                      icon
                      color="black"
                      :loading="loadingLogsTecnicos"
                      v-bind="attrs"
                      @click="downloadLogsTecnicos(row.item.valor.id)"
                      v-on="on"
                    >
                      <v-icon size="18">mdi-file-download-outline</v-icon>
                    </v-btn>
                  </template>
                  <span v-if="loadingLogsTecnicos">Baixando...</span>
                  <span v-else>Clique aqui para baixar os logs técnicos</span>
                </v-tooltip>
              </td>
              <td v-else class="button">
                {{ row.item.valor }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </template>
    </general-dialog-detalhes>
  </v-container>
</template>

<script>
  import SimulacaoBaixasService from '@/services/SimulacaoBaixasService';
  import powerupsActionsMixins from '@/mixins/powerupsActionsMixins';
  import dateFormatterMixins from '@/mixins/dateFormatterMixins';

  export default {
    components: {
      GeneralStatus: () => import('@/components/general/GeneralStatus.vue'),
      GeneralProgressBars: () => import('@/components/general/GeneralProgressBars.vue'),
      DialogCreationLog: () => import('@/components/general/DialogCreationLog'),
      DialogDelete: () => import('@/components/general/DialogDelete'),
      GeneralDialogDetalhes: () => import('@/components/general/GeneralDialogDetalhes')
    },
    mixins: [powerupsActionsMixins, dateFormatterMixins],

    props: {
      items: {
        type: Array,
        default: () => []
      },
      loading: {
        type: Boolean,
        required: true
      }
    },

    emits: ['switchProcessamentosExpirados', 'rechargeTable'],

    data: () => ({
      powerupService: SimulacaoBaixasService,
      powerupEntityName: 'Simulação de Baixas',
      search: '',
      headers: [
        {
          text: '#',
          value: 'id'
        },
        {
          text: 'Título',
          value: 'nome'
        },
        {
          text: 'Executado',
          value: 'data_processamento'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          sortable: false,
          text: 'Ações',
          value: 'actions',
          class: 'pl-4'
        }
      ],
      dialogDelete: false,
      dialogDeleteData: { id: undefined, nome: undefined }
    }),

    methods: {
      openDialogDetalhes(item) {
        this.dialogDetalhesData = [];

        let rodadas = JSON.parse(item.rodadas);
        this.dialogDetalhesData.push({ parametro: 'ORIGEM DA BASE:', valor: item.origem_ais });

        if (item.data_base) {
          this.dialogDetalhesData.push({ parametro: 'DATABASE:', valor: this.formatMonth(item.data_base) });
        }

        if (item.origem_ais === 'ARQUIVO') {
          this.dialogDetalhesData.push({
            parametro: 'ARQUIVO DO AIS:',
            arquivo_nome: item.arquivo_ais.arquivo,
            arquivo_id: item.arquivo_ais.id
          });
        } else {
          this.dialogDetalhesData.push({
            parametro: 'DATA BASE DA BASE:',
            valor: this.formatMonth(item.data_base)
          });
        }

        this.dialogDetalhesData.push(
          {
            parametro: 'ARQUIVO BAIXAS:',
            arquivo_nome: item.arquivo.arquivo,
            arquivo_id: item.arquivo.id
          },
          {
            parametro: 'ARQUIVO BAIXAS (DELIMITADOR):',
            valor: item.arquivo_delimitador
          },
          {
            parametro: 'ARQUIVO BAIXAS (INVOLUCRO):',
            valor: item.arquivo_involucro
          },
          {
            parametro: 'ARQUIVO BAIXAS (ESCAPE):',
            valor: item.arquivo_escape
          },
          {
            parametro: 'SOMENTE UAR PRINCIPAL?:',
            valor: item.somente_uar_principal ? 'Sim' : 'Não'
          },
          {
            parametro: 'HABILITAR ATRIBUTOS CORINGA?:',
            valor: item.atributos_coringa ? 'Sim' : 'Não'
          },
          {
            parametro: 'NÚMERO DE RODADAS:',
            valor: rodadas.length
          }
        );

        rodadas?.forEach((rodada, i) => {
          this.dialogDetalhesData.push({
            parametro: `ATRIBUTOS RODADA ${i + 1}:`,
            valor: rodada.valores.join(', ')
          });
        });

        if (this.userIsAdmin && ['SUCESSO', 'FALHA'].includes(item.status)) {
          this.dialogDetalhesData.push(
            { parametro: ' ', valor: ' ' },
            { parametro: 'LOGS TÉCNICOS:', valor: { id: item.id, logs_tecnicos: true } }
          );
        }

        this.dialogDetalhes = true;
      }
    }
  };
</script>

<style>
  .swithInterna label {
    font-size: 13px !important;
    margin-left: 0px !important;
  }
</style>
